import { PaymentMethodTypes, Paypal } from '@accedo/one-plugin-sdk';
import { useState } from 'react';
import styled from 'styled-components';

import { FormButton } from '#/components/Form/Form.styled';
import { FormButtonDisclaimer } from '#/components/Form/FormButton';
import { noop, remify } from '#/service/utils';
import { tb } from '#/store/translation/translation.store';

import { PaymentFormProps } from './types';

export const Text = styled.span`
  font: var(--fontStyleFootnote);
`;

export const DisclaimerWrapper = styled.div`
  margin: ${remify(45)} 0;
`;

export const PaymentPayPalForm = ({
  disclaimerText = 'web.iap.paymentFooter',
  setIsDisabled = noop,
  onPurchase,
  onFailure,
  onSuccess,
}: PaymentFormProps) => {
  const [loading, setLoading] = useState(false);

  const buyButtonText = tb('web.iap.paymentMethods.paypal.button');

  const handleClickButton = () => {
    setLoading(true);
    setIsDisabled(true);
    onPurchase(
      { paymentMethod: { type: PaymentMethodTypes.Paypal } },
      buyButtonText
    )
      .then(({ paymentMethod, isExternal = true } = {}) => {
        const paypalResult = paymentMethod?.properties as Paypal;

        if (!isExternal) {
          onSuccess();

          return;
        }

        if (paypalResult?.redirectUrl) {
          window.open(paypalResult.redirectUrl, '_self');
        }
        // there is no onSuccess call here, because in this case, success must be handled after the redirect back.
      })
      .catch(onFailure)
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Text>{tb('web.iap.paymentMethods.paypal.description')}</Text>
      <DisclaimerWrapper>
        <FormButtonDisclaimer disclaimer={tb(disclaimerText)}>
          <FormButton isLoading={loading} onClick={handleClickButton}>
            {buyButtonText}
          </FormButton>
        </FormButtonDisclaimer>
      </DisclaimerWrapper>
    </>
  );
};
